import React from "react";
import { useSelector } from "react-redux";
import {
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Box,
} from "@mui/material";

const ProfileCompletion = () => {
  const userData = useSelector((state) => state.userData.userData);

  const requiredFields = {
    "Name": !!userData?.name,
    "About": !!userData?.about,
    "Contact Info": !!userData?.contactNumber,
    "Category": userData?.category?.length > 0,
    "Genre": userData?.genres?.length > 0,
    "Social Platforms": userData?.social?.length > 0,
    "Experience": userData?.experience?.length > 0,
    "Language": userData?.languages?.length > 0,
    "Profile Pictures": userData?.profile_pictures?.length > 0,
  };

  const total = Object.keys(requiredFields).length;
  const filled = Object.values(requiredFields).filter(Boolean).length;
  const percent = Math.round((filled / total) * 100);

  const isComplete = percent === 100;

  return (
    <Card>
      <CardContent sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
        <Typography variant="h6" gutterBottom>
          Profile Completion
        </Typography>
        <Box
          position="relative"
          display="inline-flex"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress
            variant="determinate"
            value={percent}
            size={80}
            thickness={3}
            sx={{
              color: isComplete ? "green" : "#ff6200",
            }}
          />
          <Box
            top={0}
            left={0}
            bottom={0}
            right={0}
            position="absolute"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Typography variant="h6" component="div" color="text.primary">
              {`${percent}%`}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ProfileCompletion;
